<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-checkbox
          id="tickbox_studentSelectionInRiskAssessmentEnabled"
          :model-value="studentSelectionInRiskAssessmentEnabled"
          label="Enable Student Selection In Risk Assessment"
          color="primary"
          hide-details
          @update:model-value="onStudentSelectionInRiskAssessmentChanged"
        />
      </v-col>
    </v-row>

    <v-row class="pt-0" no-gutters>
      <v-col cols="12" class="pb-4">
        <cs-button
          id="btnAdminRetrieveGroupsFromVendor"
          :primary="!isReadFromCache"
          name="btnAdminRetrieveGroupsFromVendor"
          :disabled="groupsLoading || serviceEnded"
          :loading="groupsLoading"
          label="Retrieve Groups from Vendor"
          class="ma-0"
          @click="onRetrieveGroups(false)"
        ></cs-button>
        <cs-button
          id="btnAdminRetrieveGroupsFromCache"
          primary
          :disabled="!isReadFromCache || groupsLoading || serviceEnded"
          :loading="groupsLoading"
          label="Retrieve Groups from Cache"
          class="mt-0"
          @click="onRetrieveGroups(true)"
        ></cs-button>
      </v-col>
      <v-col cols="12" class="pt-2">
        <client-student-management-group
          :group-list="groupList"
          :client-sid="clientSid"
          :parent-selection-list="originalGroupList"
          :school-types="schoolTypes"
          :hide-selected="hideSelected"
          :groups-loading="groupsLoading"
          :search-term="searchTerm"
          :pagination="studentGroupPaginationInfo"
          :student-management-group-sync-diffs="studentManagementGroupSyncDiffs"
          :vendor-group-id-display-enabled="showGroupId"
          @update:group-list="onGroupListChanged"
          @update:search-term="onSearchTermChanged"
        />
      </v-col>
    </v-row>

    <cs-form-dialog
      id="dlg-client-student-management-group-generic"
      :model-value="retrieveErrorDisplayed"
      body-id="dlg-client-student-management-group-generic-body"
      heading="Student Management"
      :primary-action="{
        label: 'OK',
        eventName: 'primary-click'
      }"
      @update:model-value="onRetrieveErrorDialogChanged"
      @primary-click="onRetrieveErrorDialogChanged(false)"
    >
      <template #cs-form-dialog-content>
        <div
          v-safe-html="retrieveErrorMessage"
          :class="retrieveErrorIsError ? 'generic-error-message' : ''"
        ></div>
      </template>
    </cs-form-dialog>
  </div>
</template>

<script>
import ClientStudentManagementGroup from './ClientStudentManagementGroup';

export default {
  name: 'ClientStudentManagementGrouping',

  components: {
    ClientStudentManagementGroup
  },

  props: {
    clientSid: {
      type: String,
      required: true,
      default: ''
    },
    moduleName: {
      type: String,
      default: ''
    },
    schoolTypes: {
      type: Array,
      default: () => []
    },
    serviceEnded: {
      type: Boolean,
      default: false
    },
    groupList: {
      type: Array,
      default: () => []
    },
    originalGroupList: {
      type: Array,
      default: () => []
    },
    groupsLoading: {
      type: Boolean,
      default: false
    },
    studentManagementGroupSyncDiffs: {
      type: Array,
      default: () => []
    },
    isReadFromCache: {
      type: Boolean,
      default: false
    },
    hideSelected: {
      type: Boolean,
      default: true
    },
    searchTerm: {
      type: String,
      default: ''
    },
    studentGroupPaginationInfo: {
      type: Object,
      default: () => ({
        itemsPerPage: 30,
        page: 1,
        sortBy: []
      })
    },
    studentSelectionInRiskAssessmentEnabled: {
      type: Boolean,
      default: false
    },
    retrieveErrorDisplayed: {
      type: Boolean,
      default: false
    },
    retrieveErrorMessage: {
      type: String,
      default: ''
    },
    retrieveErrorIsError: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'changed',
    'retrieve-groups',
    'update:group-list',
    'update:search-term',
    'update:student-selection-in-risk-assessment-enabled',
    'update:retrieve-error-displayed',
    'clear-search'
  ],

  computed: {
    showGroupId() {
      return this.moduleName === 'caremonkey';
    }
  },

  methods: {
    onGroupListChanged(groupList) {
      this.$emit('update:group-list', groupList);
      this.$emit('changed');
    },

    onStudentSelectionInRiskAssessmentChanged(enabled) {
      this.$emit('update:student-selection-in-risk-assessment-enabled', enabled);
      this.$emit('changed');
    },

    onSearchTermChanged(searchTerm) {
      this.$emit('update:search-term', searchTerm);
    },

    onRetrieveGroups(readFromCache) {
      this.$emit('clear-search');
      this.$emit('retrieve-groups', readFromCache);
    },

    onRetrieveErrorDialogChanged(displayed) {
      this.$emit('update:retrieve-error-displayed', displayed);
    }
  }
};
</script>
